import _ from 'lodash';
import React, { Component } from 'react';

import FourboxSection from './fourboxSection';

import { getFourboxCategories, formatNewLines } from '../../util';

class Fourbox extends Component {

  state = {
    nextWeekActionItemsFocused: false,
  }

  goalsForCategory(category){
    return _.filter(this.props.sprintData.goals, goal => {
      return goal.category === category;
    });
  }

  getNextWeekActionItemTextboxText(){
    const { nextWeekActionItemsFocused } = this.state;
    const { nextWeekActionItems } = this.props.sprintData;

    if(nextWeekActionItemsFocused){
      return nextWeekActionItems || '';
    }
    else if(nextWeekActionItems && nextWeekActionItems !== ''){
      return nextWeekActionItems || '';
    }
    else{
      return `Itemize what ${this.props.userData.firstName} should focus on this week. We recommend the following format:\n- Stop doing this\n- Start doing this\n- Keep doing this`;
    }
  }

  renderActionItems(){
    const { editingActionItems, lastSprintOfQuarter } = this.props;
    const { thisWeekActionItems, nextWeekActionItems } = this.props.sprintData;

    if(editingActionItems && lastSprintOfQuarter){
      return (
        <div className="action-items editing">
          <div className="half">
            <h6>THIS WEEK'S ACTION ITEMS</h6>
            <textarea value={thisWeekActionItems} disabled={true} />
          </div>
          <div className="half">
            <h6>NEXT WEEK'S ACTION ITEMS</h6>
            <textarea style={{opacity:.25}} value={'(Last sprint of quarter)'} disabled={true} />
          </div>
        </div>
      )
    }
    else if(editingActionItems){
      return (
        <div className="action-items editing">
          <div className="half">
            <h6>THIS WEEK'S ACTION ITEMS</h6>
            <textarea value={thisWeekActionItems} disabled={true} />
          </div>
          <div className="half">
            <h6>NEXT WEEK'S ACTION ITEMS</h6>
            <textarea
              onFocus={() => { this.setState({ nextWeekActionItemsFocused: true }) }}
              onBlur={() => { this.setState({ nextWeekActionItemsFocused: false }) }}
              className={'editable' + ((!nextWeekActionItems || nextWeekActionItems === '') ? ' needsInput blank' : '')}
              value={this.getNextWeekActionItemTextboxText()}
              onChange={e => { this.props.updateNextWeekActionItems(e.target.value) }}
            />
          </div>
        </div>
      )
    }
    else if(nextWeekActionItems && nextWeekActionItems !== ''){
      //else if we have action items for next week - probably because it's a prior sprint
      return (
        <div className="action-items reviewing">
          <div className="half">
            <h6>THIS WEEK'S ACTION ITEMS</h6>
            <p dangerouslySetInnerHTML={{ __html: formatNewLines(thisWeekActionItems) }}></p>
          </div>
          <div className="half">
            <h6>NEXT WEEK'S ACTION ITEMS</h6>
            <p dangerouslySetInnerHTML={{ __html: formatNewLines(nextWeekActionItems) }}></p>
          </div>
        </div>
      )
    }
    else if(thisWeekActionItems && thisWeekActionItems !== ''){
      return (
        <div className="action-items">
          <h6>THIS WEEK'S ACTION ITEMS</h6>
          <p dangerouslySetInnerHTML={{ __html: formatNewLines(thisWeekActionItems) }}></p>
        </div>
      )
    }
    else{
      return null;
    }
  }

  render(){

    const sprintData = this.props.sprintData;
    // console.log('sprintData: ', sprintData);

    if(!sprintData){
      return null;
    }

    return (
      <div className='page-section no-padding fourbox'>
        {this.renderActionItems()}
        <div className="fourbox-sections">
          {_.map(getFourboxCategories(), category => {
            return <FourboxSection
              editable={this.props.editable}
              key={category.key}
              sectionClass={category.key}
              sectionName={category.name}
              sectionGoals={this.goalsForCategory(category.key)}
              updateGoalValue={this.props.updateGoalValue}
              updateGoalMeta={this.props.updateGoalMeta}
              trackGoal={this.props.trackGoal}
            />
          })}
        </div>
      </div>
    )
  }
}

export default Fourbox;



// WEBPACK FOOTER //
// ./src/components/sprint/fourbox.js